import React, {Component} from 'react';
import './App.css';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField'
import Button from "@material-ui/core/Button";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import {withSnackbar} from 'notistack';
import {bffUrl} from './config.js'
import {Card, CardContent} from "@material-ui/core";
import {DateTime} from 'luxon';


const styles = theme => ({
    container: {
        position: 'relative',
    },
});


class IngestionHelperContainer extends Component {

    constructor(props) {

        super(props);

        this.state = {
            cid: '',
            downloadableSourceUrlData: [],
            source: '',
            target: '',
            suffix: '',
            refreshMinutes: 10
        };

    }


    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };

    componentDidMount() {

        let self = this;

        setTimeout(() => {
            self.requestsLoader();
        }, 1000);

        if (sessionStorage.DOWNLOAD_SOURCE === "true") {
            this.setState({DOWNLOAD_SOURCE: true});
        }


        window.addEventListener('storage', (event) => {
            console.log(event);
            if (event.key && event.key === "DOWNLOAD_SOURCE") {
                if (event.newValue && event.newValue === "true") {
                    self.setState({DOWNLOAD_SOURCE: true})
                } else if (event.newValue && event.newValue === "false") {
                    self.setState({DOWNLOAD_SOURCE: false})
                }
            }
        })
    }


    snackBarCloseHandler = () => {
        this.setState({
            snackBarOpen: false
        })
    };

    requestsLoader = () => {

        var userEmail = sessionStorage.getItem("userEmail");

        const {cid, refreshMinutes} = this.state;
        const downloadRequestUrl = `${bffUrl}/DownloadSourceRequest?sort=createdAt%20DESC&limit=1000&where={\"requestedBy\":{\"like\":"${userEmail}"}}`;
        const getDownloadRequest = axios.create({
            baseURL: downloadRequestUrl,
            timeout: 150000
        });
        getDownloadRequest.get()
            .then(response => {
                if (response.data) {
                    response.data.map(responseData => {
                        responseData.updatedAt = DateTime.fromMillis(responseData.updatedAt).toLocaleString(DateTime.DATETIME_MED);
                        return responseData;
                    });
                    this.setState({
                        downloadableSourceUrlData: response.data
                    }, () => {

                    });
                } else {
                    this.props.enqueueSnackbar('Data Does not Exist.', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar('Failed to get results.', {
                    variant: 'warning', anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            });

    };

    getDownloadableUrl = (event) => {

        this.setState({
            downloadableSourceUrlData: []
        });
        var userEmail = sessionStorage.getItem("userEmail");

        const {cid, refreshMinutes} = this.state;

        if (cid === "") {
            this.props.enqueueSnackbar('Please Enter Cid!!', {
                variant: 'warning', anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }
            });
            return;
        }

        var cidArray = cid.split(",");

        if (cidArray.length > 1) {
            this.props.enqueueSnackbar('Only One Cid Allow At a Time!!', {
                variant: 'warning', anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }
            });
            return;
        }

        if (cid !== "") {
            const baseUrl = `${bffUrl}/ingestion/downloadRequest?cid=${cid}&email=${userEmail}&internal=false`;

            const getDownloadableUrl = axios.create({
                baseURL: baseUrl,
                timeout: 150000
            });

            getDownloadableUrl.get()
                .then(res => {
                    if (res.data) {
                        this.requestsLoader();
                        setInterval(() => {
                            // Check DownloadSourceRequest and refresh it every refreshMinute
                            this.requestsLoader();
                        }, refreshMinutes * 10000);
                        this.props.enqueueSnackbar('High quality video request created successfully, you will be notified via email once the video is ready.', {
                            variant: 'success', anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }
                        });
                    } else {
                        this.props.enqueueSnackbar('Failed to create request.', {
                            variant: 'warning', anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }
                        });
                    }
                })
                .catch(error => {
                    this.props.enqueueSnackbar('Failed to create request.', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });
                })

        }
    };


    render() {
        const {classes, theme} = this.props;
        const flex = {flexGrow: 1};

        let options = {
            filterType: 'dropdown',
            download: false,
            pagination: true,
            selectableRows: false,
            print: false,
            viewColumns: false,
            responsive: 'scroll',
            customToolbar: function (columnMeta) {
                let toolBar = (<Button aria-label="Refresh" variant="contained" onClick={self.requestsLoader}
                                       className={classes.button}>
                    Refresh
                </Button>);
                return toolBar
            }
        };

        const columns = [
            {
                name: "cid",
                label: "CID"
            },
            {
                name: "status",
                label: "Status"
            },
            {
                name: "message",
                label: "Message"
            },
            {
                name: "progress",
                label: "Progress"
            },
            {
                name: "updatedAt",
                label: "Updated at in (timezone: " + Intl.DateTimeFormat().resolvedOptions().timeZone + ")"
            },
        ];
        let self = this;

        const containerStyle = {
            minHeight: '650px'
        };

        const checkButtonStyle = {
            marginLeft: '1em'
        };

        const contentIdInputStyle = {};

        return (
            <React.Fragment>

                {/* {(sessionStorage.DOWNLOAD_SOURCE == "true" || sessionStorage.userEmail === "pooja.datrange@vuclip.com") && */}
                <Paper style={containerStyle}>

                    <Card>
                        <CardContent>

                            <Typography variant="h6" component="h3">New High Quality Video Request</Typography>


                            <Grid container spacing={1}
                                  direction="row"
                                  justify="flex-start"
                                  alignContent="flex-start"
                            >

                                <Grid item sm={3}></Grid>
                                <Grid item sm={3}>
                                    <TextField style={contentIdInputStyle} fullWidth
                                               variant="outlined"
                                               label="Enter Content ID"
                                               value={this.state.cid}
                                               onChange={this.handleChange('cid')}
                                    />
                                </Grid>


                                <Grid item sm={3} style={{paddingTop: '10px'}}>
                                    <Button variant="contained" style={checkButtonStyle} color="primary"
                                            onClick={this.getDownloadableUrl.bind(this)}
                                    >
                                        Create Download Request
                                    </Button>
                                </Grid>

                                <Grid item sm={3} style={{paddingTop: '10px'}}>
                                    <Typography variant="caption">
                                        Connection to Vuclip VPN is needed<br/>
                                        to download the high quality video.
                                    </Typography>
                                </Grid>
                            </Grid>


                        </CardContent>
                    </Card>
                    <br/>

                    {
                        this.state.downloadableSourceUrlData && Object.keys(this.state.downloadableSourceUrlData).length > 0
                            ?
                            <Grid container spacing={0}
                                  direction="row"
                                  justify="space-around"
                                  alignItems="center">

                                <Grid item sm={12}>

                                    <MUIDataTable
                                        title={`My High Quality Video Requests`}
                                        data={this.state.downloadableSourceUrlData}
                                        columns={columns}
                                        options={options}
                                    />


                                </Grid>
                            </Grid>

                            :
                            null
                    }

                    {this.state.errorMessages && this.state.errorMessages.ERROR && this.state.errorMessages.ERROR.length > 0 &&
                    <Grid container spacing={0}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            {this.state.errorMessages.ERROR.map(function (errorMessage, index) {
                                return (<Typography variant='title' key={index} color='secondary'>
                                    Error : {errorMessage.message}
                                </Typography>)
                            })}
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>}
                </Paper>
                {/* } */}
            </React.Fragment>
        );
    }
}


IngestionHelperContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default withSnackbar(withStyles(styles, {withTheme: true})(IngestionHelperContainer));
